import { findPrice } from '../prices';

export const getInsuranceLimitByOrder = (limits: GQL.IDeliveryMethodInsuranceLimit[], orderPrice: number, vatRate: number) => {
  if (!limits || limits.length === 0) {
    return null;
  }

  const limit = limits.find((l: GQL.IDeliveryMethodInsuranceLimit) => {
    // výpočet kriterijních cen (ve stejné měně jako objednávka)
    const fromPriceOrder = findPrice(l.fromPriceOrder, false, vatRate, l);
    const toPriceOrder = findPrice(l.toPriceOrder, false, vatRate, l);
    // vyhodnocení kriterií na cenu objednávky
    return (!l.fromPriceOrder || orderPrice >= fromPriceOrder) 
      && (!l.toPriceOrder || orderPrice <= toPriceOrder);
  });

  if (limit) {
    return limit;
  }

  return null;
};


// WEBPACK FOOTER //
// ./src/helpers/deliveryMethods/getInsuranceLimitByOrder.ts